export default __webpack_public_path__ + "static/media/noytrall_symbol.759feca9.svg";